import { render, staticRenderFns } from "./two_factor_authentication.vue.js?vue&type=template&id=60d45436!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./two_factor_authentication.vue?vue&type=template&id=60d45436"
import script from "./two_factor_authentication.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./two_factor_authentication.vue?vue&type=script&lang=js"
export * from "./two_factor_authentication.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./two_factor_authentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d45436')) {
      api.createRecord('60d45436', component.options)
    } else {
      api.reload('60d45436', component.options)
    }
    module.hot.accept("./two_factor_authentication.vue.js?vue&type=template&id=60d45436!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./two_factor_authentication.vue?vue&type=template&id=60d45436", function () {
      api.rerender('60d45436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "authentication/sessions/components/two_factor_authentication.vue"
export default component.exports